(() => {
  if (customElements.get('variant-visual-track')) return;
  customElements.define('variant-visual-track', class extends HTMLElement {
    connectedCallback() {
      this.reveal ||= () => {
        this.updatePanelSelection();
        const selected = this.querySelector('input:checked')?.closest('.variant-visual-choice');
        if (!selected || this.scrollWidth <= this.clientWidth) return;
        const track = this.getBoundingClientRect();
        const tile = selected.getBoundingClientRect();
        const delta = tile.left < track.left ? tile.left - track.left : tile.right > track.right ? tile.right - track.right : 0;
        if (delta) this.scrollBy({ left: delta, behavior: 'instant' });
      };
      this.setupColourPanel();
      this.addEventListener('change', this.reveal);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.reveal);
        this.observer.observe(this);
      }
      this.frame = requestAnimationFrame(this.reveal);
    }
    setupColourPanel() {
      const limit = Number(this.dataset.colourLimit);
      const choices = Array.from(this.querySelectorAll('.variant-visual-choice'));
      if (!Number.isInteger(limit) || limit < 2 || choices.length <= limit) return;
      if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
      const selected = choices.find((choice) => choice.querySelector('input:checked'));
      const visible = choices.slice(0, limit);
      if (selected && !visible.includes(selected)) visible[limit - 1] = selected;
      choices.forEach((choice) => { choice.hidden = !visible.includes(choice); });
      this.moreButton = document.createElement('button');
      this.moreButton.type = 'button';
      this.moreButton.className = 'asn-btn asn-btn-ghost colour-photo-more';
      this.moreButton.textContent = this.dataset.moreLabel || 'More colours';
      this.moreButton.setAttribute('aria-haspopup', 'dialog');
      this.panel = document.createElement('dialog');
      this.panel.id = `${choices[0].querySelector('input').id}-colour-panel`;
      this.moreButton.setAttribute('aria-controls', this.panel.id);
      this.panel.className = 'asn-modal asn-modal-end colour-photo-panel';
      this.panel.setAttribute('aria-label', this.dataset.panelHeading || 'Select a colour');
      const box = document.createElement('div');
      box.className = 'asn-modal-box colour-photo-panel__box';
      const header = document.createElement('div');
      header.className = 'colour-photo-panel__header';
      const heading = document.createElement('h2');
      heading.textContent = this.dataset.panelHeading || 'Select a colour';
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'asn-btn asn-btn-ghost asn-btn-square';
      close.textContent = '×';
      close.setAttribute('aria-label', this.dataset.closeLabel || 'Close');
      close.addEventListener('click', () => this.panel.close());
      header.append(heading, close);
      const grid = document.createElement('div');
      grid.className = 'colour-photo-panel__grid';
      choices.forEach((choice) => {
        const input = choice.querySelector('input');
        const label = choice.querySelector('label');
        if (!input || !label) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.optionInput = input.id;
        button.className = 'asn-btn asn-btn-ghost colour-photo-panel__choice';
        button.setAttribute('aria-pressed', String(input.checked));
        const image = label.querySelector('img')?.cloneNode(true);
        if (image) { image.removeAttribute('id'); image.alt = ''; button.append(image); }
        const name = document.createElement('span');
        name.textContent = input.value;
        button.append(name);
        button.addEventListener('click', () => {
          this.panel.close();
          if (!input.checked) input.click();
        });
        grid.append(button);
      });
      box.append(header, grid);
      const backdrop = document.createElement('form');
      backdrop.method = 'dialog';
      backdrop.className = 'asn-modal-backdrop';
      const dismiss = document.createElement('button');
      dismiss.textContent = this.dataset.closeLabel || 'Close';
      backdrop.append(dismiss);
      this.panel.append(box, backdrop);
      this.append(this.moreButton);
      this.after(this.panel);
      this.moreButton.addEventListener('click', () => this.panel.showModal());
    }
    updatePanelSelection() {
      if (!this.panel) return;
      const choices = Array.from(this.querySelectorAll('.variant-visual-choice'));
      const selected = choices.find((choice) => choice.querySelector('input:checked'));
      const visible = choices.slice(0, Number(this.dataset.colourLimit));
      if (selected && !visible.includes(selected)) visible[visible.length - 1] = selected;
      choices.forEach((choice) => { choice.hidden = !visible.includes(choice); });
      this.panel.querySelectorAll('[data-option-input]').forEach((button) => {
        const input = choices.map((choice) => choice.querySelector('input')).find((input) => input?.id === button.dataset.optionInput);
        button.setAttribute('aria-pressed', String(!!input?.checked));
      });
    }
    disconnectedCallback() {
      this.panel?.close?.();
      this.moreButton?.remove();
      this.panel?.remove();
      this.moreButton = this.panel = null;
      this.querySelectorAll('.variant-visual-choice').forEach((choice) => { choice.hidden = false; });
      this.removeEventListener('change', this.reveal);
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
})();
